<template>
  <el-dialog
  title="选择导出字段"
  :visible.sync="showExport"
  :before-close="close"
  center
  destroy-on-close>
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
    <el-checkbox-group v-model="columnList" @change="handleCheckedCitiesChange">
      <el-checkbox v-for="item in columnListData" :label="item" :key="item">{{item}}</el-checkbox>
    </el-checkbox-group>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="exportData" :disabled="columnList.length === 0" :loading="exportLoad">导 出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { euFarmerInfoExport } from '@/api/community.js'
export default {
  data () {
    return {
      columnList: [],
      columnListData: ['人员编号', '姓名', '性别', '民族', '身份证', '出生年月', '生产队', '人员性质', '人员类别', '仅享受收益分配标识', '现居住地', '户籍地址', '联系电话', '银行卡', '开户行', '户主', '户主身份证', '与户主关系', '户主联系电话', '承包地确权总面积', '宅基地土地使用面积', '合计份额', '份额审核状态', '份额更新时间'],
      showExport: false,
      checkAll: false,
      isIndeterminate: false,
      exportLoad: false
    }
  },
  props: {
    queryInfo: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    showDetails () {
      this.showExport = true
    },
    close () {
      this.showExport = false
    },
    exportData () {
      this.exportLoad = true
      let columnList = this.columnListData.filter((item) => this.columnList.indexOf(item) !== -1)
      euFarmerInfoExport({
        ...this.queryInfo,
        columnList
      }).then(res => {
        this.exportLoad = false
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const elink = document.createElement("a");
        elink.download = '人员信息.xls';
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      })
    },
    handleCheckAllChange(val) {
      this.columnList = val ? this.columnListData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.columnListData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnListData.length;
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 850px;
  width: 50%;
}
/deep/ .el-checkbox {
  width: 170px;
  line-height: 40px;
}
</style>